import { Box, Link, styled, Typography } from "@mui/material";

interface FooterWrapperProps {
  sidebarOpen?: boolean;
  fullWidth?: boolean;
}

export const FooterWrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    !["sidebarOpen", "fullWidth"].includes(prop as string),
})<FooterWrapperProps>(({ theme, sidebarOpen, fullWidth }) => ({
  backgroundColor: "#ffffff",
  padding: theme.spacing(1.5),
  position: "fixed",
  bottom: 0,
  left: fullWidth ? 0 : sidebarOpen ? "248px" : "calc(56px + 1px)",
  right: 0,
  width: fullWidth
    ? "100%"
    : sidebarOpen
      ? "calc(100% - 248px)"
      : "calc(100% - 56px - 1px)",
  zIndex: 1000,
  maxHeight: "200px",
  overflowY: "auto",
  borderTop: `1px solid ${theme.palette.divider}`,
  transition: theme.transitions.create(["left", "width"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  [theme.breakpoints.down("md")]: {
    left: 0,
    width: "100%",
  },
}));

export const FooterContent = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  maxWidth: "1200px",
  margin: "0 auto",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(1),
    textAlign: "center",
  },
}));

export const LinksContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(3),
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
}));

export const FooterLink = styled(Link)(({ theme }) => ({
  color: "#727272",
  textDecoration: "none",
  fontSize: "0.875rem",
  cursor: "pointer",
  "&:hover": {
    color: "#727272",
    textDecoration: "underline",
  },
}));

export const CopyrightText = styled(Typography)(({ theme }) => ({
  color: "#727272",
  fontSize: "0.875rem",
}));
